import { useEffect, useState } from "react";
import http from "@/lib/http";

/**
 * Hook that returns a map { status_key: status_label } across both source
 * types. Used to render the *current* human label for legacy activity rows
 * that stored only the status key — so renaming a status updates every
 * timeline entry retroactively, without DB migration.
 */
export default function useStatusLabelMap() {
  const [map, setMap] = useState({});
  useEffect(() => {
    let cancelled = false;
    Promise.all([
      http.get("/api/lead-statuses", { params: { source_type: "makelaar" } }).catch(() => ({ data: [] })),
      http.get("/api/lead-statuses", { params: { source_type: "particulier" } }).catch(() => ({ data: [] })),
    ]).then(([m, p]) => {
      if (cancelled) return;
      const out = {};
      for (const s of [...(m.data || []), ...(p.data || [])]) {
        if (s.key && !(s.key in out)) out[s.key] = s.label;
      }
      setMap(out);
    });
    return () => { cancelled = true; };
  }, []);
  return map;
}
